import React from 'react'
import { Modal } from 'react-bootstrap';
import { Button } from '../Button';
import { PopupBox } from '../Popup';
//AVCDAAV.002  21/03/2025  Add code for  Adding dialog component
type Props = {
    show: boolean;
    handleClose: () => void;
    children: React.ReactNode | string;
    centered?: boolean;
    header?: React.ReactNode | string;
    footerCustom?: React.ReactNode | string;
    footerAction?: {
        onClickConfirm?: () => void;
        onClickCancel?: () => void; 
    };
    width?: "small" | "medium" | "full";
    height?: string;
    closeIconOuter?: boolean;
    closeIconInner?: boolean;
    closeButtonOuter?: boolean;
    type?: "image" | "custom";
    backdropClassName?: string;
    dialogClassName?: string;
    dialogStyles?: React.CSSProperties;
    dialogBodyStyles?:React.CSSProperties;
    loading?: boolean;
    blockCloseBackdrop?: boolean;
}

const Dialog = (props: Props) => {

    function handleClick(callback?: () => void) {
        if (callback) { callback(); return; }
        props.handleClose();
    }

    return (
        <React.Fragment>
            <Modal show={props.show} onHide={props.blockCloseBackdrop ? () => {} : props.handleClose} scrollable={false} centered={props.centered}
                backdropClassName={`${props.backdropClassName}`}
                dialogClassName={`${props.dialogClassName}`}
                contentClassName={`dialog-${props.width ? props.width : "full"}-width ${props.type === "image" ? "dialog-image" : ""} ${props.loading ? "loading" : ""}`}
                style={{...props.dialogStyles}}
            >
 
                {props.closeIconOuter && <div className='close-icons close-icons-outer' onClick={props.handleClose} >×</div>}
                {props.closeIconInner && <button className='close-icons close-icons-inner' onClick={props.handleClose} >×</button>}

                {props.header && 
                    <Modal.Header closeButton={props.closeIconOuter || props.closeIconInner ? false : true}>
                        <div className='dialog-header'>{props.header}</div>
                    </Modal.Header>
                }
                <Modal.Body className={`${props.type === "image" ? "dialog-image-body" : ""}`} style={{backgroundColor: props.dialogBodyStyles?.backgroundColor}}>
                    <div className={`dialog-body`} style={{height: props.height}}>
                        {props.children}
                    </div>
                </Modal.Body>
                {props.footerCustom && <Modal.Footer>{props.footerCustom}</Modal.Footer>}
                {props.footerAction && 
                (
                    <Modal.Footer>
                        <div className='dialog-footer-btn'>
                            <Button btn_type='cancel' name='ยกเลิก' 
                                onClick={() => handleClick(props.footerAction?.onClickCancel)} 
                            />
                            <Button btn_type='confirm' name='ยืนยัน' 
                                onClick={() => handleClick(props.footerAction?.onClickConfirm)} 
                            />
                        </div>
                    </Modal.Footer>
                )}
                {props.closeButtonOuter && ( 
                    <Button btn_type='default' name='ปิด' onClick={props.handleClose} 
                        className='close-button-bottom'
                    /> 
                )}
            </Modal>
        </React.Fragment>
    )
}

Dialog.Success = (props: Props) => {
    return (
        <Dialog {...props}>
            <PopupBox type='success' style={props.dialogBodyStyles}>
                {props.children}
            </PopupBox>
        </Dialog>
    );
}

Dialog.Error = (props: Props) => {
    return (
        <Dialog {...props}>
            <PopupBox type='error' style={props.dialogBodyStyles}>
                {props.children}
            </PopupBox>
        </Dialog>
    );
}

export default Dialog;



//C-AVCDAAV.002  21/03/2025  Add code for  Adding dialog component
